import React from 'react';
import { RouteObject } from 'react-router-dom';
import AdminLayout from '../layouts/AdminLayout';
import AdminDashboard from '../pages/admin/Dashboard';
import AnnouncementsAdmin from '../pages/admin/Announcements';
import AppointmentAdmin from '../pages/admin/Appointment';
import SpreadsAdmin from '../pages/admin/Spreads';
import UsersAdmin from '../pages/admin/Users';
import AdminsPage from '../pages/admin/Admins';
import TimeSlotsAdmin from '../pages/admin/TimeSlots';
import CalendarAdmin from '../pages/admin/Calendar';

export const adminRoutes: RouteObject[] = [
    {
        path: '/admin',
        children: [
            {
                index: true,
                element: <AdminDashboard />
            },
            {
                path: 'announcements',
                element: <AnnouncementsAdmin />
            },
            {
                path: 'appointment',
                element: <AppointmentAdmin />
            },
            {
                path: 'spreads',
                element: <SpreadsAdmin />
            },
            {
                path: 'users',
                element: <UsersAdmin />
            },
            {
                path: 'admins',
                element: <AdminsPage />
            },
            {
                path: 'timeslots',
                element: <TimeSlotsAdmin />
            },
            {
                path: 'calendar',
                element: <CalendarAdmin />
            }
        ]
    }
]; 